var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongGuanbi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.354 3.646a.5.5 0 10-.708.708L7.293 8l-3.646 3.646a.5.5 0 10.707.707L8 8.707l3.646 3.646a.5.5 0 00.707-.707L8.707 8l3.647-3.646a.5.5 0 00-.707-.708L8 7.293 4.354 3.646z",
    fill: "#FE5B4C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_guanbi.1c72100b.svg";
export { SvgTongyongGuanbi as ReactComponent };